export default{
    data(){
        return{
            nama : `ooo`,
            _password : ``,
            _struktur : [],
            uri : 'erp.ama.id'
        }
    },
    methods: {
        setModelMixin(obj){
            this.nama = obj
            console.log(obj);
            if(obj !== null){
                console.log(`mixin`,JSON.parse(obj)[0].nama);
                this.nama = JSON.parse(obj)[0].nama ? JSON.parse(obj)[0].nama : ''
                console.log(`glob `,this.nama);
            }else{
                console.log(`gadaa..`);
                this.nama = ``
            }
        }
    },
}